import { render, staticRenderFns } from "./ViewMain.vue?vue&type=template&id=1b8ccd5a"
import script from "./ViewMain.vue?vue&type=script&lang=ts"
export * from "./ViewMain.vue?vue&type=script&lang=ts"
import style0 from "./ViewMain.vue?vue&type=style&index=0&id=1b8ccd5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports